import { render, staticRenderFns } from "./TicketActivition.vue?vue&type=template&id=5136d572&scoped=true&"
import script from "./TicketActivition.vue?vue&type=script&lang=js&"
export * from "./TicketActivition.vue?vue&type=script&lang=js&"
import style0 from "./TicketActivition.vue?vue&type=style&index=0&id=5136d572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136d572",
  null
  
)

export default component.exports